import { twMerge } from 'tailwind-merge'
import { useAudioTranscript } from '@renderer/hooks/audio/use-audio-transcript'
import { PARTIAL_SPEAKER_LABELS, useLiveTranscriptPreview } from '@renderer/hooks/audio/use-live-transcript-preview'

interface LiveTranscriptSnippetProps {
  className?: string
}

export function LiveTranscriptSnippet({ className }: LiveTranscriptSnippetProps) {
  const { messages } = useAudioTranscript()
  const live = useLiveTranscriptPreview()
  const lastMessage = messages.at(-1)
  const line = live
    ? { speaker: PARTIAL_SPEAKER_LABELS[live.source], text: live.text }
    : lastMessage
      ? { speaker: lastMessage.sender, text: lastMessage.text }
      : null

  if (!line) {
    return null
  }

  return (
    <span className={twMerge('text-foreground-secondary type-ui-xs flex min-w-0 flex-1 italic', className)}>
      <span className="shrink-0 whitespace-pre not-italic">{line.speaker}: </span>
      <span className="min-w-0 flex-1 truncate text-left [direction:rtl]">
        <bdi>{line.text}</bdi>
      </span>
    </span>
  )
}
